import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';
import Logo from 'assets/images/logo.jpg';

// Branded loader shown while a page/section is fetching data. Pass `fullPage={false}`
// to drop it into a smaller area (a tab, a modal section) instead of the whole viewport.
const Loader = ({ fullPage = true, label, minHeight }) => {
    const { t } = useTranslation();
    const text = label === null ? null : (label || t('loading'));

    const mark = (
        <div className="__loader_mark">
            <span className="__loader_ring" />
            <div className="__loader_photo">
                <img src={Logo} alt="" />
            </div>
        </div>
    );

    if (!fullPage) {
        return (
            <div className="__loader __loader_inline">
                {mark}
                {text && <p className="__loader_label">{text}</p>}
            </div>
        );
    }

    return (
        <div className="__loader __loader_page" style={minHeight ? { minHeight } : undefined}>
            {mark}
            {text && <p className="__loader_label">{text}</p>}
        </div>
    );
};

export default Loader;
